// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactSVG from 'react-svg';

import ComboFilter from '../ComboFilter';
import DateFilter from '../DateFilter';
import { Wrapper, svgStyle } from './style';

import { optionsPlatforms } from '../../pages/AdvancedSearch';
import langues from '../../translations/lang.json';
import Close from '../../assets/images/close.svg';
import { setCriteria, makeSearch, setYearsMustUse } from '../../actions/search';
import { initialState } from '../../reducers/search';
import { getOrganizations } from '../../actions/organizations';
import Button from '../Button';

import { FormattedMessage } from 'react-intl';
import { formatMessage } from '../../CurrentLocale';

const getPlatformLabel = key => {
  const { label } = optionsPlatforms.find(({ value }) => value === key) || {
    label: key
  };

  return label;
};

const cleanLabel = (label = '') => {
  return label
    .replace(/./, label.toUpperCase()[0])
    .replace(/&amp;/g, '&')
    .replace(/<\/?sup>/gm, '');
};

const getTypeLabel = label => {

  let id = '';

  switch (label) {
    case 'post':
      id = 'advancedSearch.type.post';
      break;
    case 'article':
      id = 'advancedSearch.type.article';
      break;
    case 'chapitre':
      id = 'advancedSearch.type.chapter';
      break;
    case 'compterendu':
      id = 'advancedSearch.type.review';
      break;
    case 'evenements':
      id = 'advancedSearch.type.events';
      break;
    case 'numerorevue':
      id = 'advancedSearch.type.issue';
      break;
    case 'livre':
      id = 'advancedSearch.type.book';
      break;
    case 'appelacontribution':
      id = 'advancedSearch.type.appelacontribution';
      break;
    case 'colloque':
      id = 'advancedSearch.type.colloque';
      break;
    case 'journeedetude':
      id = 'advancedSearch.type.journeedetude';
      break;
    case 'seminaire':
      id = 'advancedSearch.type.seminaire';
      break;
    case 'bourseprixetemploi':
      id = 'advancedSearch.type.bourseprixetemploi';
      break;
    case 'informationsdiverses':
      id = 'advancedSearch.type.informationsdiverses';
      break;
    case 'cycledeconferences':
      id = 'advancedSearch.type.cycledeconferences';
      break;
    case 'ecoledete':
      id = 'advancedSearch.type.ecoledete';
      break;
    case 'appeldoffres':
      id = 'advancedSearch.type.book';
      break;
    default:
      id = 'advancedSearch.type.editorial';
  }

  return formatMessage({ id });
};

class FacetFilter extends Component<Props, State> {
  state = {
    tags: []
  };

  componentDidMount() {
    this.props.getOrganizations();
  }

  static getDerivedStateFromProps(props, state) {
    const {
      search: {
        platforms,
        author = [],
        type = [],
        translations = [],
        journalsPublications = [],
        booksPublications = [],
        institutionsPublications = [],
        hypothesesPublications = [],
        access = [],
        subscribers = [],
        years = {}
      },
      translations: _translations
    } = props;

    const tagsPlatforms = Object.keys(platforms)
      .filter(key => !!platforms[key])
      .map(i => ({
        label: getPlatformLabel(i),
        id: i,
        value: 0,
        facet: 'platform'
      }));

    const tagAccess = access.length === 0 && subscribers.length === 0
    ? [
        {
          label: formatMessage({ id: 'facetFilter.all_accesses' }),
          id: 'all-access',
          value: 0,
          facet: 'access',
        },
      ]
    : access.map((key) => ({
        label: FacetFilter.getAccessLabel(key),
        id: key,
        value: 0,
        facet: 'access',
      }));

    const tagsAuthors = author.map(key => ({
      label: key,
      id: key,
      value: 0,
      facet: 'author'
    }));

    const tagsType = type.map(key => ({
      label: getTypeLabel(key),
      id: key,
      value: 0,
      facet: 'type'
    }));

    const tagsTranslations = translations.map(key => ({
      label: langues[key] || key,
      id: key,
      value: 0,
      facet: 'translations'
    }));

    const _journalsPublications = platforms.OJ ? journalsPublications : [];
    const _booksPublications = platforms.OB ? booksPublications : [];
    const _hypothesesPublications = platforms.HO ? hypothesesPublications : [];

    const tagsJP = _journalsPublications.map(key => ({
      label: _translations[key] || key,
      id: key,
      value: 0,
      facet: 'journalsPublications'
    }));

    const tagsBP = _booksPublications.map(key => ({
      label: _translations[key] || key,
      id: key,
      value: 0,
      facet: 'booksPublications'
    }));

    const tagsHP = _hypothesesPublications.map(key => ({
      label: _translations[key] || key,
      id: key,
      value: 0,
      facet: 'hypothesesPublications'
    }));

    const tagsSubscribers = subscribers.map(key => ({
      label: key,
      id: key,
      value: 0,
      facet: 'subscribers'
    }));

    let tagsDate = '';
    if (years.mustUse) {
      tagsDate = [
        {
          label: `${years.min} - ${years.max}`,
          id: `${years.min} - ${years.max}`,
          value: 0,
          facet: 'years'
        }
      ];
    }

    return {
      ...state,
      tags: [
        ...tagsPlatforms,
        ...tagAccess,
        ...tagsAuthors,
        ...tagsType,
        ...tagsTranslations,
        ...tagsJP,
        ...tagsBP,
        ...tagsHP,
        ...tagsSubscribers,
        ...tagsDate
      ]
    };
  }

  handleSelect = (option) => {
    const { tags } = this.state;
    const { facet } = option;

    if (facet === 'access' || facet === 'subscribers') {
      let newTags;
      let newCriteria;

      if (option.id === 'all-access') {
        newTags = tags.filter((tag) => tag.facet !== 'access' && tag.facet !== 'subscribers');
        newCriteria = {
          access: [],
          subscribers: [],
        };
      }
      else {
        newTags = tags.filter((tag) => tag.facet !== 'access' && tag.facet !== 'subscribers');
        newTags.push(option);

        newCriteria = {
          access: newTags.filter((i) => i.facet === 'access').map((i) => i.id),
          subscribers: newTags.filter((i) => i.facet === 'subscribers').map((i) => i.id),
        };
      }

      this.setState({ tags: newTags }, () => {
        this.props.setCriteria(newCriteria);
        window.location.reload();
      });
    }

    else {
      const alreadySelected = tags.find((tag) => tag.id === option.id);
      const newTags = alreadySelected
        ? tags.filter((tag) => tag.id !== option.id)
        : [...tags, option];

      if (
        [
          'author',
          'type',
          'translations',
          'journalsPublications',
          'booksPublications',
          'hypothesesPublications',
        ].includes(facet)
      ) {
        this.props.setCriteria({
          [facet]: newTags
            .filter((i) => i.facet === facet)
            .map((i) => i.id),
        });
      }
      else if (facet === 'platform') {
        this.props.setCriteria({
          platforms: {
            OJ: newTags.find((i) => i.id === 'OJ') !== undefined,
            OB: newTags.find((i) => i.id === 'OB') !== undefined,
            HO: newTags.find((i) => i.id === 'HO') !== undefined,
            CO: newTags.find((i) => i.id === 'CO') !== undefined,
          },
          journalsPublications: initialState.journalsPublications,
          booksPublications: initialState.booksPublications,
          hypothesesPublications: initialState.hypothesesPublications,
        });
      }
      else if (facet === 'years') {
        this.props.setYearsMustUse(false);
      }

      this.setState({ tags: newTags }, () => {
        this.reRunSearch();
      });
    }
  };

  handleChangeYear = years => {
    years.mustUse = true;
    this.props.setCriteria({ years });

    this.reRunSearch();
  };

  removeAllTag = () => {
    this.props.setCriteria({
      platforms: initialState.platforms,
      type: initialState.type,
      access: initialState.access,
      author: initialState.author,
      translations: initialState.translations,
      journalsPublications: initialState.journalsPublications,
      booksPublications: initialState.booksPublications,
      hypothesesPublications: initialState.hypothesesPublications,
      subscribers: initialState.subscribers,
      years: initialState.years
    });

    this.reRunSearch();
  };

  reRunSearch = () => {
    const {
      search: { pagination }
    } = this.props;

    this.props.setCriteria({ pagination: { ...pagination, currentPage: 1 } });
    this.props.makeSearch();
  };

  static getAccessLabel = label => {
    let id = '';

    if (label === 'info:eu-repo/semantics/openAccess') {
      id = 'open_access';
    } else if (label === 'info:eu-repo/semantics/restrictedAccess') {
      id = 'restricted';
    } else {
      id = 'embargo_period';
    }

    return formatMessage({ id });
  };

  render() {
    const {
      counts: {
        platform: { counts: countedPlatform = {} } = {},
        translations: { counts: countedTranslations = {} } = {},
        type: { counts: countedType = {} } = {},
        author: { counts: countedAuthor = {} } = {},
        access: { counts: countedAccess = {} } = {},
        'journals-publication': { counts: countedJournals = {} } = {},
        'books-publication': { counts: countedBooks = {} } = {},
        'hypotheses-publication': { counts: countedHypos = {} } = {},
        subscribers: { counts: countedSubscribers = {} } = {}
      },
      search: { years },
      translations,
      organizations
    } = this.props;
    const { tags } = this.state;

    const itemsPlatform = [
      {
        label: 'Hypotheses',
        id: 'HO',
        value: countedPlatform.HO || 0
      },
      {
        label: 'OpenEdition Journals',
        id: 'OJ',
        value: countedPlatform.OJ || 0
      },
      {
        label: 'OpenEdition Books',
        id: 'OB',
        value: countedPlatform.OB || 0
      },
      {
        label: 'Calenda',
        id: 'CO',
        value: countedPlatform.CO || 0
      }
    ];

    const itemsAccess = [
      {
        label: formatMessage({ id: 'open_access' }),
        id: 'info:eu-repo/semantics/openAccess',
        value: countedAccess['info:eu-repo/semantics/openAccess'] || 0
      },
      {
        label: formatMessage({ id: 'facetFilter.all_accesses' }),
        id: 'all-access',
        value: 0,
      },
      {
        label: formatMessage({ id: 'restricted' }),
        id: 'info:eu-repo/semantics/restrictedAccess',
        value: countedAccess['info:eu-repo/semantics/restrictedAccess'] || 0
      },
      {
        label: formatMessage({ id: 'embargo_period' }),
        id: 'info:eu-repo/semantics/embargoedAccess',
        value: countedAccess['info:eu-repo/semantics/embargoedAccess'] || 0
      }
    ];

    // Générer itemsSubscribers en utilisant les données d'organisation
    const itemsSubscribers = [];

    if (
      organizations &&
      organizations.data &&
      Array.isArray(organizations.data) &&
      organizations.data.length > 0
    ) {
      const org = organizations.data[0];
      if (org && org.shortname) {
        // Récupérer seulement le count pour l'organisation de l'utilisateur
        const count = countedSubscribers[org.shortname] || 0;

        // Toujours afficher le filtre si l'organisation existe, même avec count = 0
        itemsSubscribers.push({
          label: formatMessage(
            { id: 'facetFilter.documents_acquired_by_institution' },
            { institution: org.name || org.shortname }
          ),
          id: org.shortname,
          value: count,
          facet: 'subscribers'
        });
      }
    }
    if (itemsSubscribers.length > 0) {
      // Si aucune organisation n'est sélectionnée, on affiche tous les items d'accès
      itemsAccess.shift(); // Supprimer le premier item d'accès (open access) pour éviter la redondance
    }
    const itemsAccessOrdered = [...itemsSubscribers, ...itemsAccess];

    const itemsLangues = Object.keys(countedTranslations).map(key => {
      const label = langues[key] || key;

      return {
        label,
        id: key,
        value: countedTranslations[key]
      };
    });

    const itemsType = Object.keys(countedType).map(key => {
      return {
        label: getTypeLabel(key),
        id: key,
        value: countedType[key]
      };
    });

    const itemsAuthor = Object.keys(countedAuthor).map(key => {
      return {
        label: cleanLabel(key),
        id: key,
        value: countedAuthor[key]
      };
    });

    const itemsJournals = Object.keys(countedJournals).map(key => {
      return {
        label: cleanLabel(translations[key] || key),
        id: key,
        value: countedJournals[key]
      };
    });

    const itemsBooks = Object.keys(countedBooks).map(key => {
      return {
        label: cleanLabel(translations[key] || key),
        id: key,
        value: countedBooks[key]
      };
    });

    const itemsHypos = Object.keys(countedHypos).map(key => {
      return {
        label: cleanLabel(translations[key] || key),
        id: key,
        value: countedHypos[key]
      };
    });

    const platformsSelected = tags.filter(tag => tag.facet === 'platform');

    let typeName = formatMessage({ id: 'facetFilter.documents.type' });
    if (platformsSelected.length === 1) {
      if (platformsSelected[0].id === 'OB')
        typeName = formatMessage({ id: 'facetFilter.documents.type' });
      else if (platformsSelected[0].id === 'CO')
        typeName = formatMessage({ id: 'facetFilter.events.type' });
    }

    return (
      <Wrapper>
        {itemsAccess.length > 1 && (
          <ComboFilter
            checkedItems={tags.filter(
              tag => tag.facet === 'access' || tag.facet === 'subscribers'
            )}
            facet="access"
            onSelect={this.handleSelect}
            title={formatMessage({ id: 'facetFilter.access.type' })}
            items={itemsAccessOrdered}
            canBeSort
          />
        )}
        {itemsPlatform.length > 1 && (
          <ComboFilter
            checkedItems={platformsSelected}
            facet="platform"
            onSelect={this.handleSelect}
            title={formatMessage({ id: 'facetFilter.platform' })}
            items={itemsPlatform}
          />
        )}
        {itemsLangues.length > 1 && (
          <ComboFilter
            checkedItems={tags.filter(tag => tag.facet === 'translations')}
            facet="translations"
            onSelect={this.handleSelect}
            title={formatMessage({ id: 'facetFilter.languages' })}
            items={itemsLangues}
            canBeSort
          />
        )}
        {itemsType.length > 1 && (
          <ComboFilter
            checkedItems={tags.filter(tag => tag.facet === 'type')}
            facet="type"
            onSelect={this.handleSelect}
            title={typeName}
            items={itemsType}
            canBeSort
          />
        )}
        {itemsAuthor.length > 1 && (
          <ComboFilter
            checkedItems={tags.filter(tag => tag.facet === 'author')}
            facet="author"
            onSelect={this.handleSelect}
            title={formatMessage({
              id:
                platformsSelected.length === 0
                  ? 'facetFilter.authors_publication'
                  : 'facetFilter.authors'
            })}
            items={itemsAuthor}
            canBeSort
          />
        )}
        {itemsJournals.length > 1 && (
          <ComboFilter
            checkedItems={tags.filter(
              tag => tag.facet === 'journalsPublications'
            )}
            facet="journalsPublications"
            onSelect={this.handleSelect}
            title={formatMessage({ id: 'facetFilter.journals' })}
            items={itemsJournals}
            canBeSort
          />
        )}
        {itemsBooks.length > 1 && (
          <ComboFilter
            checkedItems={tags.filter(tag => tag.facet === 'booksPublications')}
            facet="booksPublications"
            onSelect={this.handleSelect}
            title={formatMessage({ id: 'facetFilter.publishers' })}
            items={itemsBooks}
            canBeSort
          />
        )}
        {itemsHypos.length > 1 && (
          <ComboFilter
            checkedItems={tags.filter(
              tag => tag.facet === 'hypothesesPublications'
            )}
            facet="hypothesesPublications"
            onSelect={this.handleSelect}
            title={formatMessage({ id: 'facetFilter.blogs' })}
            items={itemsHypos}
            canBeSort
          />
        )}
        <DateFilter
          title={formatMessage({ id: 'facetFilter.years' })}
          years={years}
          onChange={this.handleChangeYear}
        />
      </Wrapper>
    );
  }
}

const mapStateToProps = ({
  results,
  search,
  facets,
  translations: { translations },
  organizations
}) => ({
  counts: facets.counts,
  search,
  translations,
  organizations
});

export default connect(
  mapStateToProps,
  dispatch => ({
    setCriteria: arg => dispatch(setCriteria(arg)),
    setYearsMustUse: arg => dispatch(setYearsMustUse(arg)),
    makeSearch: () => dispatch(makeSearch()),
    getOrganizations: () => dispatch(getOrganizations())
  })
)(FacetFilter);



// WEBPACK FOOTER //
// ./src/components/FacetFilter/index.js